import { render, staticRenderFns } from "./TestPdfDownload.vue?vue&type=template&id=c0c929e8&"
import script from "./TestPdfDownload.vue?vue&type=script&lang=js&"
export * from "./TestPdfDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports